<!--
 * @Descripttion: diySkin
 * @version: 1.0.0
 * @Author: Jiang ShareFont
 * @Date: 2023-05-19 10:52:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-25 10:56:26
-->
<template>
  <div>
    <common-header></common-header>
    <div class="record">
      <el-menu
        mode="horizontal"
        :default-active="query.status"
        @select="handleSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-menu-item index="0" class="el-menu-item">未结束</el-menu-item>
        <el-menu-item index="3" class="el-menu-item">已过期</el-menu-item>
        <el-menu-item index="2" class="el-menu-item">已结束</el-menu-item>
      </el-menu>
      <div class="table flex justify-between">
        <div class="header flex justify-between align-center">
        <div class="filters flex">
          <div class="reward-name">
            <el-input
              placeholder="请输入奖项名称关键词"
              prefix-icon="Search"
              v-model="query.searchkeyword"
              clearable
              size="mini"
            >
            </el-input>
          </div>
          <div class="version" v-show="query.status == 0">
            <el-select
              v-model="query.pause"
              placeholder="进行状态"
              clearable
              size="mini"
              style="width: 100px;"
            >
              <el-option
                v-for="(item, index) in pause"
                :key="item.value"
                :label="item.value"
                :value="index"
              >
              </el-option>
            </el-select>
          </div>
          <div class="search">
            <el-button class="search-button font-14" @click="fetchData"  size="mini" type="primary"
              >查询</el-button
            >
            <el-button class="search-button font-14" @click="refresh"  size="mini" type="primary"
              >刷新</el-button
            >
          </div>
        </div>
        <div class="new">
          <el-button class="search-button font-14" @click="toNew"  size="mini" type="primary"
            >创建抽奖</el-button
          >
        </div>
      </div>
        <el-table
          :data="list"
          height="950px"
          cell-class-name="cell-class"
          style="width: 100%"
          v-loading="loading"
          stripe
        >
          <el-table-column prop="lottery_id" width="100" label="ID"></el-table-column>
          <el-table-column label="奖项" min-width="180">
            <template slot-scope="scope">
              <el-tooltip class="box-item" effect="dark" placement="top">
                <p class="reward">
                  {{
                    scope.row.detail && scope.row.detail.length > 0
                      ? `${scope.row.detail[0].name}：${scope.row.detail[0].desc}*${scope.row.detail[0].num}等`
                      : ""
                  }}
                </p>
                <template slot="content">
                  <p v-for="item in scope.row.detail" :key="item.id">
                    {{ `${item.name}:${item.desc}*${item.num}` }}
                  </p>
                </template>
              </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column label="模式" min-width="101">
          <template slot-scope="scope">
            <p v-if=" scope.row.lottery_type ==1">大转盘</p>
            <p v-if=" scope.row.lottery_type ==2">九宫格</p>
            <p v-if=" scope.row.lottery_type ==3">摇一摇</p>
            <p v-if=" scope.row.lottery_type ==4">扭蛋机</p>
			<p v-if=" scope.row.lottery_type ==5">盲盒</p>
			<p v-if=" scope.row.lottery_type ==6">砸金蛋</p>
          </template>
        </el-table-column>
        <el-table-column label="参与人数" min-width="101">
          <template slot-scope="scope">
            <p>{{ scope.row.join_user_count || "--" }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="进行状态"
          min-width="117"
          v-if="query.status == 0"
        >
          <template slot-scope="scope">
            <p
              :style="{
                color: scope.row.pause === '0' ? '#008000' : '#FFA500',
              }"
            >
              {{ scope.row.pause === "0" ? "已开启" : "未开启" }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="166" prop="create_time">
        </el-table-column>

        <el-table-column
          label="过期时间"
          min-width="184"
          v-if="query.status != 2"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.end_time || "--" }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="结束时间"
          min-width="184"
          v-if="query.status == 2"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.finish_time || "--" }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="兑奖截止时间"
          min-width="184"
          prop="prize_end_time"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.prize_end_time || "--" }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="right"
          :min-width="query.status == 0 ? '420' : '380'"
        >
          <template slot-scope="scope">
            <div class="operations flex justify-end ">
              <p
                class="red"
                v-if="scope.row.pause === '0' && query.status === '0'"
                @click="stop(scope.row.lottery_id)"
              >
                终止
              </p>
              <p
                @click="copyLottery(scope.row.lottery_id,scope.row.version_id)"
                v-if="['2', '3'].includes(query.status)"
              >
                复制发起
              </p>
              <p
                @click="toCompile(scope.row)"
                v-if="query.status === '0'"
              >
                编辑
              </p>
              <p
                :class="{
                  red: scope.row.pause === 0,
                }"
                @click="open(scope)"
                v-if="query.status === '0'"
              >
                {{ scope.row.pause === "0" ? "暂停" : "开启" }}
              </p>
              <p
                @click="invite(scope)"
                v-if="query.status === '0'"
              >
                邀请码
              </p>
              <p @click="toRewardList(scope.row.lottery_id)">现场大屏</p>
              <p @click="exportWin(scope.row.lottery_id)">导出中奖名单</p>
			  <p @click="reOpen(scope.row.lottery_id)" v-if="query.status === '2'">结束后再次开启</p>
              <p
                class="yellow"
                v-if="
                  scope.row.later_expire == '1' &&
                  query.status === '0' &&
                  (scope.row.version_id == 2 || scope.row.version_id == 3)
                "
                @click="fnRenewnopay(scope.row.lottery_id)"
              >
                点击延期
              </p>
              <p
                class="yellow"
                v-if="
                  query.status === '3' &&
                  (scope.row.version_id == 2 || scope.row.version_id == 3)
                "
                @click="fnRenewnopay(scope.row.lottery_id)"
              >
                点击延期
              </p>

              <p
                class="delete"
                @click="toDelete(scope.row.lottery_id)"
                v-if="query.status === '2'"
              >
                删除
              </p>
            </div>
          </template>
        </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          :currentPage="query.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="sizes, prev, pager, next, jumper"
          :total="query.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <common-footer></common-footer>
    <LoginBox ref="login"></LoginBox>
    <el-dialog title="邀请码"  :visible.sync="showDialog" width="370px">
    <template #default>
      <div class="qr-code">
        <div>分享、转发、复制链接、公众号抽奖等操作请至小程序内进行</div>
        <img :src="inviteCode" alt="" />
        <div class="tips flex justify-center align-center">
          <el-button class="btn" @click="downLoad">下载</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
  </div>
</template>
<script>
import { getDZPList, openLottery, inviteQrcode, stopLottery, getPyWins, checkDZPBuy, postRenewnopay, deleteLottery, postReOpen  } from '../api/api'
import LoginBox from './loginBox.vue'
import VueQr from 'vue-qr'
import CommonHeader from './header.vue'
import CommonFooter from './footer.vue'
export default {
  name: 'list',
  data() {
    return {
      quota: '',
      mc: '',
      list: [],
      pause: [{value: '已开启'}, { value: '未开启' }],
      loading: false,
      query: {
        searchkeyword: '',
        version_id: '',
        status: '0',
        page: 1,
        perpage: 10,
        total: 0
      },
      inviteCode: '',
      showDialog: false
    }
  },
  components: {
    LoginBox,
    VueQr,
    CommonHeader,
    CommonFooter
  },
  methods: {
    fetchData() {
      this.loading = true
      getDZPList(this.query, this.$cookie.getCookie('token')).then(
        (response) => {
          if (response.data.code === 200) {
            this.list = response.data.data.data
            this.query.total = response.data.data.count - 0
            this.loading = false
          }
        },
        (reject) => {
          this.showLogin = false
          this.noQrcode = true
        }
      )
    },
    /**
     * 翻页
     */
    handleCurrentChange(e) {
      this.query.page = e
      this.fetchData()
    },
    /**
     * 每页条数切换
     */
    handleSizeChange(e) {
      this.query.perpage = e
      this.fetchData()
    },
    handleSelect(e) {
      this.query.status = e
      this.list.length = 0
      this.fetchData()
    },
    login_fn(type) {
      this.showLogin = true
      this.fullscreenLoading = true
      clearInterval(this.checkTime)
      this.fetchQrcode()
    },
    close_Login() {
      this.showLogin = false
      clearInterval(this.checkTime)
    },
    /**
     * 开启抽奖
    */
    open(s) {
      openLottery({lottery_id: s.row.lottery_id, pause: s.row.pause === '0' ? 1 : 0}, this.$cookie.getCookie('token')).then(
        (response) => {
          if (response.code === 200) {
            this.$message.success({
              message: s.row.pause === '0' ? '暂停成功' : '开启成功'
            })
            this.fetchData()
          }
        },
        (reject) => {
          this.showLogin = false
          this.noQrcode = true
        }
      )
    },
    refresh() {
      Object.assign(this.query, {
        pause: '', // 1暂停 0 开启
        searchkeyword: '', // 输入关键词
        page: 1

      })
      this.fetchData()
    },
    toNew() {
      this.$router.push('/create')
    },
    toCompile(s) {
      console.log(s)
      if(s.pause == 0){
        this.$message.error('请先暂停活动，再编辑。');
        return false;
      }
      this.$router.push('/create?id=' + s.lottery_id)
    },
    copyLottery(id) {
      this.$router.push(`/create?renew=1&id=${id}`)
    },
    invite(s) {
      var page
      if (s.row.lottery_type === '1') {
        page = 'lottery%2Fjackpot%2Fdetail'
      }
      if (s.row.lottery_type === '2') {
        page = 'lottery%2Fnine%2Fdetail'
      }
      if (s.row.lottery_type === '3') {
        page = 'lottery%2Fyao%2Fdetail'
      }
      if (s.row.lottery_type === '4') {
        page = 'lottery%2Fniu%2Fdetail'
      }
	  if (s.row.lottery_type === '5') {
	    page = 'lottery%2Fbox%2Fdetail'
	  }
	  if (s.row.lottery_type === '6') {
	    page = 'lottery%2Fegg%2Fdetail'
	  }
      inviteQrcode({lottery_id: s.row.lottery_id, page: page}, this.$cookie.getCookie('token')).then(
        (response) => {
          if (response.data.code === 200) {
            this.inviteCode = response.data.data.invite_qrcode
            this.showDialog = true
          }
        },
        (reject) => {
          this.showLogin = false
          this.noQrcode = true
        }
      )
    },
    toRewardList(s) {
      this.$router.push('/screen?id=' + s)
    },
    exportWin(s) {
      getPyWins({lottery_id: s}, this.$cookie.getCookie('token')).then(
        (response) => {

        },
        (reject) => {
          this.$message({
            type: 'info',
            message: '操作成功,等待下载'
          })
          setTimeout(() => {
            const elt = document.createElement('a')
            elt.setAttribute('href', `https://download.goubudian.com/Public/csv/dzp_${s}.csv`)
            elt.setAttribute('download', '中奖名单.csv')
            elt.style.display = 'none'
            document.body.appendChild(elt)
            elt.click()
            document.body.removeChild(elt)
          }, 3000)
        }
      )
    },
	reOpen(s){
		postReOpen({lottery_id: s}, this.$cookie.getCookie('token')).then(
		  (response) => {
			    debugger
			  if (response.code === 200) {
			    this.$message({
			      type: 'info',
			      message: '操作成功'
			    })
				setTimeout(() => {
					 this.$router.push('/create?id=' + s)
				 
				}, 1000)
			  
			  }
			
	
		
		  },
		  (reject) => {
			debugger
		  
		  }
		)
		
	},
    stop(id) {
      this.$confirm('该抽奖在有效期内，是否提前结束该抽奖', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          stopLottery({lottery_id: id}, this.$cookie.getCookie('token')).then(
            (response) => {
              if (response.code === 200) {
                this.$message({
                  type: 'info',
                  message: '操作成功'
                })
                this.fetchData()
              }
            },
            (reject) => {
            }
          )
        })
        .catch(() => {})
    },
    fnRenewnopay(id) {
      checkDZPBuy({}, this.$cookie.getCookie('token')).then(
        (response) => {
          if (response.data.code === 200) {
            this.quota = response.data.data.normal
            this.mc = response.data.data.vip
            if (this.mc && this.mc.order_id) {
              // 已开通会员，直接续费
              this.$confirm('是否延长该有效期？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
              })
                .then(async () => {
                  postRenewnopay({lottery_id: id}, this.$cookie.getCookie('token')).then(
                    (response) => {
                      if (response.code === 200) {
                        this.$message({
                          type: 'info',
                          message: '操作成功'
                        })
                        this.fetchData()
                      }
                    },
                    (reject) => {
                    }
                  )
                })
                .catch(() => {
                })
            } else {
              this.$message({
                type: 'error',
                message: '请先开通会员'
              })
            }
          }
        },
        (reject) => {
        }
      )
    },
    toDelete(id) {
      this.$confirm('是否删除该活动？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          deleteLottery({lottery_id: id}, this.$cookie.getCookie('token')).then(
            (response) => {
              if (response.code === 200) {
                this.$message({
                  type: 'info',
                  message: '操作成功'
                })
                this.fetchData()
              }
            },
            (reject) => {
            }
          )
        })
        .catch(() => {
        })
    }
  },
  created() {},
  mounted() {
    if (this.$cookie.getCookie('token') === '') {
      console.log(this.$cookie.getCookie('token'))
      this.$refs.login.login_fn()
    } else {
      this.fetchData()
    }
  }
}
</script>

<style scoped lang="scss">
.record {
  padding: 66px 77px 0;
  min-width: 1200px;
  .header {
    width: 100%;
    padding: 0px 14px;
    // background-color: #ffffff;
    // border-radius: 5px;
    // box-shadow: -1px 2px 5px rgba(0, 0, 0, 0.16);
    box-sizing: border-box;
    margin: 10px 0;
  }
  .filters {
    .reward-name,
    .version,
    .time {
      margin-right: 15px;
    }
    .reward-name {
      width: 189px;
    }
    .version {
      width: 100px;
    }
  }
  .el-menu-item {
    height: 38px;
    line-height: 38px;
  }
  .reward {
    color: #2672ff;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 140px;
  }
  .version {
    width: 64px;
    text-align: center;
  }
  .base,
  .higher {
    color: #5eb9fb;
    border: 1px solid #d7ecfa;
  }
  .professional {
    color: #00b277;
    border: 1px solid #e6f8f2;
  }
  .vip {
    color: #fcaf72;
    border: 1px solid #ffe3ce;
  }
  .plugin {
    color: #ccc;
    border: 1px solid #ccc;
  }
  .table {
    height: 715px;
    margin-top: 0px;
    padding: 15px;
    background-color: #fff;
    // box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    flex-direction: column;
    .pagination {
      text-align: right;
      margin-top: 20px;
    }
  }
  .operations {
    p {
      padding-right: 20px;
      color: #5eb9fb;
      cursor: pointer;
      &:nth-last-child(1) {
        padding-right: 0;
      }
    }
    .red {
      color: #da2945;
    }
    .yellow {
      color: #fcaf72;
    }
  }
}
.search-button {
  // background-color: #f82602;
  color: #fff;
}
.qr-code {
  text-align: center;
  .subtitle {
    padding: 15px 0 15px;
  }
  .header {
    padding: 0 0 30px 0;
  }
  img {
    width: 160px;
    height: 160px;
    margin-top: 20px;
  }
  .tips {
    padding-top: 25px;
    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
      margin-top: 0;
    }
    .btn {
      background-color: #3377ff;
      width: 70px;
      height: 30px;
      border-radius: 6px;
      color: #fff;
    }
  }
}
:deep(.el-menu--horizontal) {
  .el-menu-item {
    margin: 0 20px;
    background: #fff;
    &:hover {
      border-bottom: 2px solid #3377ff;
      background: #fff;
    }
  }
  .is-active {
    background: #fff;
    background-color: #fff !important;
  }
}
.delete {
  color: #ff0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/list.vue